import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ITeacherStaffInterview } from '../models/teacherStaffInterview';

@Injectable({
  providedIn: 'root'
})
export class TeacherStaffInterviewService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getTeacherStaffInterviewByCaseId(caseId: string): Observable<ITeacherStaffInterview> {
        const url = environment.apiBaseUrl + endpoints.getTeachStaffInterviewByCaseId.replace(':caseId', caseId);
        return this.http.get<ITeacherStaffInterview>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateTeacherStaffInterview(data: ITeacherStaffInterview): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateTeachStaffInterview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}